import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Github, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0A0E14] text-gray-500 py-12 md:py-16 relative overflow-hidden border-t border-white/5">
      <div className="absolute inset-0 pro-grid opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Brand */}
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-5">
              <div className="w-8 h-8 md:w-9 md:h-9 bg-gradient-to-br from-green-400 to-emerald-500 rounded-lg flex items-center justify-center font-bold text-xs md:text-sm">
                M
              </div>
              <span className="text-lg md:text-xl font-bold text-white">MBhost</span>
            </div>
            <p className="text-gray-400 mb-5 md:mb-6 leading-relaxed max-w-sm text-xs md:text-sm">
              Enterprise-grade cloud infrastructure built for Indian developers and startups.
              <br />
              <span className="text-green-400/60 text-[10px] md:text-xs">A unit of MBT Ventures Ltd.</span>
            </p>
            
            <div className="flex items-center gap-2 md:gap-3">
              {[Twitter, Linkedin, Github, Mail].map((Icon, index) => (
                <a 
                  key={index}
                  href="#" 
                  className="w-8 h-8 md:w-9 md:h-9 bg-white/5 hover:bg-green-500/10 border border-white/5 hover:border-green-500/20 rounded-lg flex items-center justify-center text-gray-400 hover:text-green-400 transition-all duration-200"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-white font-semibold mb-3 md:mb-4 text-xs md:text-sm">Product</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="/#features" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Features
                </a>
              </li>
              <li>
                <a href="/#pricing" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Pricing
                </a>
              </li>
              <li>
                <a href="/#security" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Security
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Documentation
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-3 md:mb-4 text-xs md:text-sm">Legal</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link to="/privacy" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/refunds" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Cancellation & Refunds
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Shipping & Delivery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-500 hover:text-green-400 transition-colors text-xs md:text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
          <p className="text-gray-600 text-[10px] md:text-xs text-center md:text-left">
            © 2025 MBhost Cloud Pvt Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-4 md:gap-6 text-[10px] md:text-xs">
            <Link to="/privacy" className="text-gray-600 hover:text-green-400 transition-colors">Privacy</Link>
            <Link to="/terms" className="text-gray-600 hover:text-green-400 transition-colors">Terms</Link>
            <Link to="/contact" className="text-gray-600 hover:text-green-400 transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};